module.exports = __webpack_public_path__ + "assets/57527bba2dd1c7cb9b772b228ceed11e.png";